import React, {ReactElement, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {IElementHtml} from '../../../incase-domain/elements/html';
import {showHtmlEditorModalAction} from '../../../store/actions/html.actions';
import {useHtmlIframe} from '../../../hooks/useHtmlIFrame';

interface ElementHtmlComponentProps {
    element: IElementHtml;
}

function ElementHtmlComponent(props: ElementHtmlComponentProps): ReactElement {
    const {element} = props;
    const dispatch = useDispatch();

    const dragStartPosition = useRef<{x: number; y: number} | null>(null);
    const {containerRef} = useHtmlIframe(element);

    const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>): void => {
        dragStartPosition.current = {x: event.clientX, y: event.clientY};
    };

    const handleMouseUp = (event: React.MouseEvent<HTMLDivElement>): void => {
        if (!dragStartPosition.current || event.button === 2) {
            dragStartPosition.current = null;
            return;
        }

        const {x, y} = dragStartPosition.current;
        const deltaX = Math.abs(event.clientX - x);
        const deltaY = Math.abs(event.clientY - y);

        const dragThreshold = 5;
        if (deltaX < dragThreshold && deltaY < dragThreshold) {
            event.stopPropagation();
            dispatch(showHtmlEditorModalAction());
        }

        dragStartPosition.current = null;
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
            }}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
        >
            <div
                style={{
                    background: element.color,
                    color: element.fontColor,
                    width: '100%',
                    height: '100%',
                }}
                className="c-html u-events-none"
                id={`html-id-${element.id}`}
                ref={containerRef}
            />
        </div>
    );
}

export default ElementHtmlComponent;
